// extracted by mini-css-extract-plugin
export default {"container":"CampaignHeroSocialLinks_container__+RR3U"};